
import { IncludePdfsInArchiveMode } from "@/plugins/ubl/models/ubl-dossier-config";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	props: {
		value: {
			type: Number as ()=>IncludePdfsInArchiveMode
		},
		label: {
			type: [String, Object as ()=>TranslateResult]
		}
	},
	computed: {
		items():ISelectItem<IncludePdfsInArchiveMode>[]{
			return [
				{
					text: this.$ct("none"),
					value: IncludePdfsInArchiveMode.NO_PDFS_IN_ARCHIVE
				},
				{
					text: this.$ct("only-main"),
					value: IncludePdfsInArchiveMode.ONLY_MAIN_PDF
				},
				{
					text: this.$ct("all-pdfs"),
					value: IncludePdfsInArchiveMode.ALL_PDFS
				}
			];
		}
	},
	methods: {
		onInput(value:IncludePdfsInArchiveMode){
			this.$emit("input", value);
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default.include-pdfs-in-archive-mode-values"
	}
});
